import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function Proof() {
  return <section className="w-full bg-text-brown py-20 md:py-32 text-ivory" data-id="element-86">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center" data-id="element-88">
          <SparklesIcon className="w-8 h-8 text-gold mb-8" data-id="element-89" />
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif leading-tight mb-8" data-id="element-90">
            En solo 7 días, pasarás de despertarte tres veces por noche a tener
            un sueño ininterrumpido.
          </h2>
          <p className="text-lg md:text-xl text-taupe font-light leading-relaxed max-w-2xl" data-id="element-91">
            Sentirás cómo la "nube" que rodea tus pensamientos desaparece,
            permitiéndote tomar decisiones rápidas y precisas otra vez, tal como
            lo hacías hace 10 años.
          </p>
        </motion.div>
      </div>
    </section>;
}